// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionLayout_wrapper__SO4o3"};